import { useCallback } from 'react'

import { TableDataCall } from 'components/Table/api'
import { TableGenericRequest, TableResponse } from 'components/Table/types'
import { fetchAssignUsersList } from 'features/account/api'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { ClinicalReviewAccordion } from 'utils/clinicalReview/accordionPreference'
import { DropDownEnvelope } from 'utils/types/DropDownEnvelope'
import { DropDownResponse } from 'utils/types/DropDownResponse'
import { Envelope } from 'utils/types/Envelope'

import {
  importReferral,
  getActivityLogs,
  saveNewParentOrChildReferral,
  getChildReferralDetail,
  getParentReferralDetail,
  saveNewAttachments,
  getReferralSourcePdf,
  getAttachmentDoc,
  getQuestionView,
  submitQuestion,
  getQuestionAnswers,
  setHoldReferral,
  setLostReferral,
  setBulkHoldReferral,
  setBulkLostReferral,
  setBulkCommunityReview,
  getReferralForGridview,
  getRefLists,
  getPatientMatch,
  savePendingPatient,
  submitReferralToHchb,
  markInsuranceValidation,
  childReferralStatusUpdate,
  childReferralApproveReject,
  referralManualTriggering,
  getCommentLogs,
  getSexOffenderList,
  sexOffenderMatch,
  getRefDenialReasons,
  getPayerLists,
  waystarMatchRequest,
  wayStarSubmit,
  deleteReferral,
  deleteParentReferral,
  wayStarValidate,
  updateChildReferral,
  updateParentReferral,
  parentReferralStatusUpdate,
  parentReferralApproveReject,
  parentReferralFacilities,
  getRoutes,
  getReferralStatus,
  waystarDelete,
  getIntegrationFeatures,
  sendOutBoundCommunication,
  getMessagesFromSource,
  childReferralStatusRevise,
  getTodoList,
  updateTaskListStatus,
  getPccPatientDetails,
  getMostRecentDenialReason,
  getIntegrationSourceStatus,
  getInsuranceDetailsByPatientId,
  callHoldReasons,
  callHoldReasonsByOrg,
  callLostReasons,
  unLockReferral,
  addMappedCommunity,
  updateMappedCommunity,
  getCommunitiesForUnmatched,
  getMappedCommunities,
  getUnmappedCommunities,
  callReviseToClinicalReview,
  referralRegeneratePDF,
  updateClinicalReviewStatus,
  updateClinicalReviewStatusChild,
  getFacilitiesForClinicalReview,
  getPverifyPayerLists,
  pVerifyMatchRequest,
  pVerifyValidate,
  savePayerNote,
  deletePayerNote,
  reorderInsurance,
  pVerifySubmit,
  pVerifyDeletePayer,
  assignedUsersList,
  deleteLeadAgent,
  addReferralUsers,
  assignedUsersCount,
  confirmReadAlert,
  fetchReferralUpdates,
  getAllSourceHospitals,
  getCommunityFaxStatus,
  getParentFaxStatus,
  fetchQueuedChildReferralDetail,
  fetchQueuedParentReferralDetail,
  getAIGenerationStatusForQA,
  getAIGenerationStatusForParentQA,
  getAIGenerationStatusForCommunityQA,
  importReferralFile,
  updateInsurance,
  parentReferralFacilitiesForSkip,
  parentReferralSkip,
  childReferralSkip,
  manuallyAdmitRef,
  addNotes,
  deleteNotes,
  editNotes,
  getAllNotes,
  getNoteById,
  getEngagementTypesForNotes,
  createBroadcastOutBoundCommunication,
  unLockQueuedReferral,
  lockQueuedReferral,
  getMatchedPayerList,
  getAssignedUserList,
  createCustomFilter,
  editCustomFilter,
  deleteCustomFilter,
  getAllCustomFilter,
  setDefaultCustomFilter,
  addPrimaryRationale,
  updatePrimaryRationale,
  deletePrimaryRationale,
  deleteSecondaryRationale,
  getSecRationaleByOrg,
  getSecRationaleDetails,
  updateSecondaryRationale,
  addSecondaryRationale,
  getPrimaryRationalesByOrg,
  getRationalesRoutes,
  getReferralSourceRationaleByRoute,
  getRoutesForReferralSource,
  callLostReasonsByOrg,
  getReferralScreenPanels,
  saveReferralScreenPanels,
  deleteReferralScreenPanels,
  getDuplicateRefList,
  deleteRule,
  pauseRule,
  getAllCategoryDomo,
  getAllOrganizationDomo,
  getSexOffenderCheckRslt,
  getInsuranceCheckRslt,
  getReferralCommunityCapability,
  getCommunityCapabilities,
  addCapabilitiesReferral,
  saveReferralCapabilities,
  fetchManagedCareMasterAdmissionStatus,
  triggerManagedCareMaster,
  updateReferralMcmFields,
  getReferralDrugPrices,
  getSubmissionCommunityTotals,
  getFacilitiesByPatientId,
} from '../api'
import {
  getSelectedKeyword,
  referralActions,
  selectReferralDetail,
  selectReferralList,
  getAllKeyword,
  getIsQuestionAnswersLoaded,
  getCategoryDetailList,
  getSelectedReferral,
  selectedParentReferral,
  getSelectedListTab,
  getReferralListRoot,
  getRouteList,
  getSourceHospitalList,
  getParentFilterItems,
  getChildFilterItems,
  getDefaultViewApplied,
  getRefreshForSourceMessageData,
  getSourceMessageTabToSet,
  getReferralListInputs,
  getIsTaskListPending,
  getOrganizationList,
  waystarValidationChanged,
  getHoldReasons,
  getLostReasons,
  getDenialReasonList,
  getReferralGridViewList,
  getFacilityListForParentFilter,
  getFacilityListForChildFilter,
  getInsuranceProvider,
  getPVerifyLinks,
  pVerifyValidationChanged,
  getSelectedParentTab,
  getFaxStatusRefresh,
  getRefreshForRefList,
  getGridViewAccordionDetails,
  getShowDocumentBool,
  getGridViewZoomedListId,
  getSelectedPatientFacilityId,
  getReloadPatientRefdata,
  getChildRefdataForNav,
  getShowLock,
  getMappedPverifyPayorsFullList,
  getSelectedAssignedUsers,
  getNoteTypeFullList,
  getSourcehospListForParentFilter,
  getSourcehospListForChildFilter,
  getCustomColumn,
  getRefRouteList,
  getLostRationaleListForChildFilter,
  getLostRationaleListForParentFilter,
  getHoldRationaleListForChildFilter,
  getHoldRationaleListForParentFilter,
  getParentRefOfDuplicateRefs,
  isParentPathOrigin,
  isQueuedPathOrigin,
  getQueuedchildRefId,
  getQueuedFileId,
  isDialogOpen,
  isNotesDrawerOpen,
  getNoteIdToEdit,
  isSideDrawerOpen,
  getCapabilityViewMode,
  getCapabilityExpandedAccordion,
  getClinicalReviewAccordionPreference,
} from '../store'
import {
  ActivityLogsResponse,
  AdmissionStats,
  Categories,
  QuestionRequest,
  Referral,
  ReferralList,
  AnswerList,
  KeywordDetail,
  HoldReferral,
  LostReferral,
  BulkHoldRequest,
  BulkLostRequest,
  BulkCommunityReviewRequest,
  BulkActionEnvelope,
  ReferralsGidview,
  CardReferral,
  CardResponse,
  PendingPatient,
  HchbSubmitRequest,
  MarkInsuranceValidationRequest,
  ReferralApproveRejectRequest,
  SexOffenderMatchBody,
  WaystarMatchRequest,
  ParentReferralApproveReject,
  QuestionAnswer,
  ReferralListType,
  OutboundMessageRequest,
  ReferralFilters,
  MessagesFromSourceRequest,
  TaskListRequest,
  UpdateTaskListStatus,
  ReferralListTypeInputs,
  ReferralListInputsParams,
  ChildReferralFilters,
  UnLockReferralData,
  MappedCommunitiesRequest,
  CommunitiesForUnmatchedRequest,
  AddMappedCommunityRequest,
  SubmitClinicalReviewParentDTO,
  SubmitClinicalReviewChildDTO,
  DenialResponse,
  CategoryResponse,
  PVerifyLinks,
  PVerifyMatchRequest,
  PVerifySubmitObject,
  PVerifyValidateRequest,
  SavePayerNoteRequest,
  ReorderInsuranceRequest,
  AssignLeads,
  AssignListResponse,
  AssignedUsersReq,
  DeleteAssignedUserReq,
  AssignedUserResponse,
  AddUsersReq,
  ActivityLogsRequest,
  ConfirmReadAlertRequest,
  InsuranceDetailReq,
  ReferralUpdatesResData,
  CommunityFaxReq,
  FaxStatusResponse,
  ChildReferralFiltersProps,
  ParentReferralFiltersProps,
  BoolResp,
  ClearIndividualReferralProps,
  GridStatusFiltersProps,
  QuestionResponse,
  InsuranceInfo,
  GridViewAccordionStore,
  GridViewAccordionProps,
  ChildReferralSkipSubmitRequest,
  DeleteReferral,
  ParentCommunityListRequest,
  CommunityListForSkipRequest,
  ParentReferralDetailRequest,
  RefManualAdmitReq,
  CreateNotes,
  AllNotesList,
  EditNotes,
  BroadcastOutboundMessageRequest,
  ChildReferralDetailsForRefSource,
  AssignedUsers,
  SelectedAssignedUser,
  EngagementTypes,
  CustomColumn,
  CustomColumnReq,
  CreateCustomFilter,
  EditCustomFilter,
  SetDefaultCustomFilter,
  AddPrimaryRationaleReq,
  UpdatePrimaryRationaleReq,
  DenialReasonReq,
  UpdateDenialReasonReq,
  RationaleList,
  HoldRationaleByOrgReq,
  RefPanelObject,
  DuplicaterefReq,
  ReferralCapabilityRequestPayload,
  CommunityCapabilitiesReqBody,
  AddCapabilityReferralReqBody,
  ReferralCapabilitiesData,
  AttachmentsInfo,
  MCMTriggerStatus,
  MCMFieldsUpdateRequest,
  ReferralDrugPriceRequest,
  ReferralDrugPriceResponse,
  SubmissionCommunityTotalsRequest,
  SubmissionCommunityTotalsResponse,
} from '../types'

export type ReferralsServiceOperators = {
  importReferralFile: (data: FormData) => Promise<Envelope>
  getReferralList: (data: TableGenericRequest, endPoint: string) => Promise<TableResponse>
  getActivityLogList: (data: ActivityLogsRequest) => Promise<ActivityLogsResponse>
  addNewParentOrChildReferral: (data: Referral) => Promise<Envelope>
  addNewAttachment: (data: FormData) => Promise<Envelope>
  referralManualUpload: (data: FormData) => Promise<Envelope>
  updateChildReferral: (data: Referral) => Promise<Envelope>
  updateParentReferral: (data: Referral) => Promise<Envelope>
  getChildReferralDetail: (id: number) => Promise<Envelope>
  getParentReferralDetail: (data: ParentReferralDetailRequest) => Promise<Envelope>
  putReferralList: (data: object) => void
  referralList: ReferralList
  putReferralDetail: (data: Referral) => void
  putReferralMcmStatus: (data: AdmissionStats) => void
  putReferralAttachmentDetail: (data: AttachmentsInfo | undefined) => void
  referralDetail: Referral
  setSelectedKeyword: (keywords?: KeywordDetail[]) => void
  getSelectedKeyword: KeywordDetail[]
  setAllKeyword: (keywords?: KeywordDetail[]) => void
  getAllKeyword: KeywordDetail[]
  setParentFilterItems: (filters?: ParentReferralFiltersProps) => void
  setChildFilterItems: (filters?: ChildReferralFiltersProps) => void
  setGridStatusFilterItems: (filters?: GridStatusFiltersProps) => void
  getParentFilterItems: ReferralFilters
  getChildFilterItems: ChildReferralFilters
  getDefaultViewApplied: { parent: boolean; community: boolean }
  setDefaultViewApplied: (applied: { parent?: boolean; community?: boolean }) => void
  setIsQuestionAnswersLoaded: (isloaded?: boolean) => void
  getIsQuestionAnswersLoaded: boolean
  getReferralSourcePdf: (patientId: number, isHighlightedPdf: boolean) => Promise<Envelope>
  getAttachmentDoc: (id: number) => Promise<Envelope>
  getQuestionView: (data: QuestionRequest) => Promise<QuestionResponse>
  saveSubmitQuestion: (data: AnswerList) => Promise<Envelope>
  getQuestionAnswers: (data: QuestionAnswer) => Promise<Envelope>
  holdReferral: (data: HoldReferral) => Promise<Envelope>
  lostReferral: (data: LostReferral) => Promise<Envelope>
  bulkHoldReferral: (data: BulkHoldRequest) => Promise<BulkActionEnvelope>
  bulkLostReferral: (data: BulkLostRequest) => Promise<BulkActionEnvelope>
  bulkCommunityReview: (data: BulkCommunityReviewRequest) => Promise<BulkActionEnvelope>
  getReferralGridview: (permission: number[]) => Promise<ReferralsGidview>
  getRefList: (data: CardReferral) => Promise<CardResponse>
  getPatientList: (id: number) => Promise<Envelope>
  savePendingRequest: (data: PendingPatient) => Promise<Envelope>
  submitToHchb: (data: HchbSubmitRequest) => Promise<Envelope>
  markInsuranceValidation: (data: MarkInsuranceValidationRequest) => Promise<Envelope>
  updateChildReferralStatus: (
    patientId: number,
    statusId: number,
    userId?: string,
    roleId?: string,
  ) => Promise<Envelope>
  updateChildReferralApproveReject: (data: ReferralApproveRejectRequest) => Promise<Envelope>
  setReferralTriggering: (data: { patientId: number }) => Promise<Envelope>
  getCommentLogList: (id: number) => Promise<ActivityLogsResponse>
  getSexOffenderLists: (id: number) => Promise<Envelope>
  applySexOffenderMatch: (body: SexOffenderMatchBody) => Promise<Envelope>
  getDenialReasons: (id: number) => Promise<ReferralsGidview>
  setCategoryDetails: (categories?: Categories[]) => void
  getCategoryDetails: Categories[]
  setWaystarMatch: (waystarMatch: WaystarMatchRequest) => void
  setPVerifyMatch: (pVerifyMatch: PVerifyMatchRequest) => void
  getPayerList: () => Promise<Envelope>
  getPVerifyPayerList: () => Promise<Envelope>
  waystarMatchRequest: (body: WaystarMatchRequest) => Promise<Envelope>
  pVerifyMatchRequest: (body: PVerifyMatchRequest) => Promise<Envelope>
  waystarPayerDelete: (body: WaystarMatchRequest) => Promise<Envelope>
  pVerifyPayerDelete: (body: PVerifyMatchRequest) => Promise<Envelope>
  waystarSubmit: (patientId: number) => Promise<Envelope>
  pVerifySubmit: (pVerifyObject: PVerifySubmitObject) => Promise<Envelope>
  waystarValidate: (body: WaystarMatchRequest) => Promise<Envelope>
  pVerifyValidate: (body: PVerifyValidateRequest) => Promise<Envelope>
  savePayerNote: (body: SavePayerNoteRequest) => Promise<Envelope>
  deletePayerNote: (id: number) => Promise<Envelope>
  reorderInsurance: (body: ReorderInsuranceRequest) => Promise<Envelope>
  getSelectedReferral: number
  setSelectedReferral: (id: number) => void
  selectedParentReferral: number
  setSelectedParentReferral: (id: number) => void
  getSelectedListTab: number
  setSelectedListTab: (data: number) => void
  getSelectedParentTab: number
  setSelectedParentTab: (data: number) => void
  getCapabilityViewMode: number
  setCapabilityViewMode: (data: number) => void
  getCapabilityExpandedAccordion: string | false
  setCapabilityExpandedAccordion: (data: string | false) => void
  getClinicalReviewAccordionPreference: ClinicalReviewAccordion | null
  setClinicalReviewAccordionPreference: (data: ClinicalReviewAccordion | null) => void
  deleteReferral: (data: DeleteReferral) => Promise<Envelope>
  deleteParentReferral: (data: DeleteReferral) => Promise<Envelope>
  updateParentReferralStatus: (data: ParentCommunityListRequest) => Promise<Envelope>
  updateParentReferralApproveReject: (data: ParentReferralApproveReject) => Promise<Envelope>
  updateParentReferralSkip: (data: ParentReferralApproveReject) => Promise<Envelope>
  updateChildReferralSkip: (data: ChildReferralSkipSubmitRequest) => Promise<Envelope>
  getParentReferralFacilities: (data: ParentCommunityListRequest) => Promise<Envelope>
  getParentReferralFacilitiesForSkip: (data: CommunityListForSkipRequest) => Promise<Envelope>
  updateClinicalReviewStatus: (data: SubmitClinicalReviewParentDTO) => Promise<Envelope>
  updateClinicalReviewStatusChild: (data: SubmitClinicalReviewChildDTO) => Promise<Envelope>
  getFacilitiesForClinicalReview: (data: ParentCommunityListRequest) => Promise<Envelope>

  getAllRoutes: () => Promise<DropDownEnvelope>
  getRoutesForRefSources: () => Promise<DropDownEnvelope>
  setRouteList: (list: DropDownResponse[]) => void
  setRefRouteList: (list: DropDownResponse[]) => void
  getRouteList: DropDownResponse[]
  getRefRouteList: DropDownResponse[]
  setGridViewAccordionDetails: (data: GridViewAccordionProps) => void
  gridViewAccordionDetails: GridViewAccordionStore
  setGridViewZoomedListId: (id: number | null) => void
  gridViewZoomedListId: number | null
  setOrganizationList: (list: DropDownResponse[]) => void
  setMappedPverifyPayorsFullList: (list: DropDownResponse[]) => void
  organizationList: DropDownResponse[]
  getAllReferralStatus: (permission: number[]) => Promise<DropDownEnvelope>
  referralListRoot: ReferralListType
  setReferralListRoot: (type: ReferralListType) => void
  getIntegrationFeatures: (id: number) => Promise<Envelope>
  sendOutBoundCommunication: (data: OutboundMessageRequest) => Promise<Envelope>
  getMessagesFromSource: (requestBody: MessagesFromSourceRequest) => Promise<Envelope>
  getRefreshForSourceMessageData: boolean
  getRefreshForRefList: boolean
  setRefreshForSourceMessageData: (data: boolean) => void
  setRefreshForRefList: () => void
  reviseChildReferralStatus: (patientId: number, statusId: number) => Promise<Envelope>
  reviseToClinicalReview: (patientId: number, statusId: number, note: string) => Promise<Envelope>
  setSourceMessageTabToSet: (tabVal: number) => void
  getSourceMessageTabToSet: number

  getTodoList: (data: TaskListRequest) => Promise<Envelope>
  updateTodoItem: (data: UpdateTaskListStatus) => Promise<Envelope>
  getReferralListInputs: ReferralListTypeInputs
  setReferralListInputs: (type: string, data: ReferralListInputsParams) => void
  getPccPatientDetails: (orgUuid: string, patientId: number) => Promise<Envelope>

  getRecentDenialReason: (data: { patientFacilityId: number }) => Promise<Envelope>
  setIsTaskListPending: (data: boolean) => void

  getIsTaskListPending: boolean
  getIntegrationSourceStatus: (id: number) => Promise<Envelope>
  getInsuranceDetailsByPatientId: (data: InsuranceDetailReq) => Promise<Envelope>
  setWaystarValidationChanged: () => void
  setPVerifyValidationChanged: () => void
  waystarValidationChanged: boolean
  pVerifyValidationChanged: boolean

  getHoldReasons: () => Promise<DropDownEnvelope>
  getHoldReasonsByOrg: (body: HoldRationaleByOrgReq) => Promise<DropDownEnvelope>
  setHoldReasons: (list: DropDownResponse[]) => void
  holdReasons: DropDownResponse[]
  getLostReasons: () => Promise<DropDownEnvelope>
  getLostReasonsByOrg: (body: HoldRationaleByOrgReq) => Promise<DropDownEnvelope>
  setLostReasons: (list: DropDownResponse[]) => void
  lostReasons: DropDownResponse[]
  unlockReferral: (data: UnLockReferralData) => Promise<Envelope>
  unmappedCommunitiesList: (data: string) => Promise<Envelope>
  mappedCommunitiesList: (data: MappedCommunitiesRequest) => Promise<Envelope>
  getCommunitiesForUnmatched: (data: CommunitiesForUnmatchedRequest) => Promise<DropDownEnvelope>
  addMappedCommunity: (data: AddMappedCommunityRequest) => Promise<Envelope>
  updateMappedCommunity: (data: AddMappedCommunityRequest) => Promise<Envelope>
  regeneratePDF: (data: { patientId: number }) => Promise<Envelope>
  setDenialReasonList: (list: DenialResponse[]) => void
  denialReasonList: DenialResponse[]
  setReferralGridViewList: (list: CategoryResponse[]) => void
  referralGridViewList: CategoryResponse[]
  setFacilityListForParentFilter: (list: DropDownResponse[]) => void
  facilityListForParentFilter: DropDownResponse[]
  setFacilityListForChildFilter: (list: DropDownResponse[]) => void
  facilityListForChildFilter: DropDownResponse[]
  mappedPverifyPayorsFullList: DropDownResponse[]
  insuranceProvider: number
  setInsuranceProvider: (data: number) => void
  pVerifyLinks: PVerifyLinks
  setPVerifyLinks: (data: PVerifyLinks) => void
  getAssignUsersList: (data: AssignLeads) => Promise<AssignListResponse>
  fetchAssignedUsersList: (data: AssignedUsersReq) => Promise<AssignListResponse>
  deleteAssignedRefUser: (data: DeleteAssignedUserReq) => Promise<Envelope>
  addReferralUsers: (data: AddUsersReq) => Promise<AssignedUserResponse>
  getAssignedUsersCount: (data: number) => Promise<Envelope>
  confirmReadAlert: (data: ConfirmReadAlertRequest) => Promise<Envelope>
  getReferralUpdates: (data: number) => Promise<ReferralUpdatesResData>
  setReferralComparisonId: (data: number) => void
  getSourceHospitalList: () => Promise<Envelope>
  getParentFaxStatus: (data: CommunityFaxReq) => Promise<FaxStatusResponse>
  getCommunityFaxStatus: (data: CommunityFaxReq) => Promise<FaxStatusResponse>
  setFaxStatusRefresh: () => void
  faxStatusRefresh: boolean
  setOcrCompletionStatus: (data: boolean) => void
  setAIProcessingStatus: (data: boolean) => void
  setSourceHospitalList: (list: DropDownResponse[]) => void
  sourceHospitalList: DropDownResponse[]
  getQueuedChildReferralDetail: (id: number) => Promise<Envelope>
  getQueuedParentReferralDetail: (id: number) => Promise<Envelope>
  getAIGenerationStatusForQA: (id: number) => Promise<BoolResp>
  getAIGenerationStatusForParentQA: (id: number) => Promise<BoolResp>
  getAIGenerationStatusForCommunityQA: (id: number) => Promise<BoolResp>
  clearIndividualParentFilter: (data: ClearIndividualReferralProps) => void
  clearIndividualChildFilter: (data: ClearIndividualReferralProps) => void
  resetParentFilterItems: () => void
  resetChildFilterItems: () => void
  showDocument: boolean
  setShowDocument: () => void
  updateInsurance: (data: InsuranceInfo) => Promise<Envelope>
  manuallyAdmitRef: (data: RefManualAdmitReq) => Promise<Envelope>
  addNotes: (data: CreateNotes) => Promise<Envelope>
  editNotes: (data: EditNotes) => Promise<Envelope>
  deleteNotes: (data: number) => Promise<Envelope>
  getAllNotes: (data: AllNotesList) => Promise<Envelope>
  getEngagementTypesForNotes: (data: number) => Promise<Envelope>
  getNotesById: (data: number) => Promise<Envelope>
  sendBroadcastOutBoundCommunication: (data: BroadcastOutboundMessageRequest) => Promise<Envelope>

  getSelectedPatientFacilityId: number
  setSelectedPatientFacilityId: (data: number) => void
  reloadPatientRefdata: boolean
  setReloadPatientRefdata: () => void
  getChildRefdataForNav: ChildReferralDetailsForRefSource
  setChildRefdataForNav: (data: ChildReferralDetailsForRefSource) => void
  unlockQueuedReferral: (data: UnLockReferralData) => Promise<Envelope>
  showLock: boolean
  assignedUsers: SelectedAssignedUser
  setShowLock: (data: boolean) => void
  setAssignedUsers: (data: DropDownResponse | null) => void
  lockQueuedReferral: (data: number) => Promise<Envelope>
  getMatchedPayerList: () => Promise<Envelope>
  getAssignedUserList: (data: AssignedUsers) => Promise<Envelope>
  setNoteTypeFullList: (data: EngagementTypes[]) => void
  getNoteTypeFullList: EngagementTypes[]
  setSourcehospListForParentFilter: (list: DropDownResponse[]) => void
  sourcehospListForParentFilter: DropDownResponse[]
  setSourcehospListForChildFilter: (list: DropDownResponse[]) => void
  sourcehospListForChildFilter: DropDownResponse[]
  setLostRationaleListForChildFilter: (list: DropDownResponse[]) => void
  lostRationaleListForChildFilter: DropDownResponse[]
  setLostRationaleListForParentFilter: (list: DropDownResponse[]) => void
  lostRationaleListForParentFilter: DropDownResponse[]
  setHoldRationaleListForChildFilter: (list: DropDownResponse[]) => void
  holdRationaleListForChildFilter: DropDownResponse[]
  setHoldRationaleListForParentFilter: (list: DropDownResponse[]) => void
  holdRationaleListForParentFilter: DropDownResponse[]
  customColumnFilters: CustomColumn
  setCustomColumnFilter: (data: CustomColumnReq) => void
  createCustomFilter: (data: CreateCustomFilter) => Promise<Envelope>
  editCustomFilter: (data: EditCustomFilter) => Promise<Envelope>
  deleteCustomFilter: (id: string) => Promise<Envelope>
  getAllCustomFilter: (id: string, filterModule: number, isParentList: boolean) => Promise<Envelope>
  setDefaultCustomFilter: (data: SetDefaultCustomFilter) => Promise<Envelope>
  createPrimaryRationale: (data: AddPrimaryRationaleReq) => Promise<Envelope>
  updatePrimaryRationale: (data: UpdatePrimaryRationaleReq) => Promise<Envelope>
  deletePrimaryRationale: (id: string) => Promise<Envelope>
  createSecondaryRationale: (data: DenialReasonReq) => Promise<Envelope>
  updateSecondaryRationale: (data: UpdateDenialReasonReq) => Promise<Envelope>
  deleteSecondaryRationale: (id: string) => Promise<Envelope>
  getSecondaryRationaleByOrg: (data: RationaleList) => Promise<TableResponse>
  getSecondaryRationaleDetails: (id: number) => Promise<Envelope>
  getPrimaryRationale: (id: number) => Promise<DropDownEnvelope>
  getReferralSourceRoute: () => Promise<DropDownEnvelope>
  getReferralSourceRationalesByRoute: (id: number | null) => Promise<Envelope>
  getRefScreenPanels: (id: number) => Promise<Envelope>
  saveRefScreenPanels: (data: RefPanelObject) => Promise<Envelope>
  deleteRefScreenPanels: (screenKey: number, panelKey: number) => Promise<Envelope>
  getParentRefOfDuplicateRefs: number
  setParentRefOfDuplicateRefs: (id: number) => void
  getDuplicateReferralList: (data: DuplicaterefReq) => Promise<Envelope>
  isParentPathOrigin: boolean
  setIsParentPathOrigin: (val: boolean) => void
  isQueuedPathOrigin: boolean
  setIsQueuedPathOrigin: (val: boolean) => void
  getQueuedchildRefId: number
  setQueuedchildRefId: (id: number) => void
  getQueuedFileId: number
  setQueuedFileId: (id: number) => void
  isDialogOpen: boolean
  setIsDialogOpen: (val: boolean) => void
  isNotesDrawerOpen: boolean
  setIsNotesDrawerOpen: (val: boolean) => void
  noteIdToEdit: number | null
  setNoteIdToEdit: (id: number | null) => void
  isSideDrawerOpen: boolean
  setIsSideDrawerOpen: (val: boolean) => void
  pauseRule: (id: number, pauseState: boolean) => Promise<Envelope>
  deleteRule: (id: number) => Promise<Envelope>
  getAllCategoryDomo: () => Promise<Envelope>
  getAllOrganizationDomo: () => Promise<Envelope>
  getReferralCommunityCapability: (data: ReferralCapabilityRequestPayload) => Promise<Envelope>
  getCommunityCapabilities: (data: CommunityCapabilitiesReqBody) => Promise<Envelope>
  addCapabilitiesReferral: (data: AddCapabilityReferralReqBody) => Promise<Envelope>
  saveReferralCapabilities: (data: ReferralCapabilitiesData) => Promise<Envelope>
  getSexOffenderCheckRslt: (id: number) => Promise<Envelope>
  getInsuranceCheckRslt: (id: number) => Promise<Envelope>
  getManagedCareMasterAdmissionStatus: (id: number) => Promise<Envelope>
  triggerManagedCareMasterAdmission: (data: MCMTriggerStatus) => Promise<Envelope>
  updateMcmRequiredFields: (data: MCMFieldsUpdateRequest) => Promise<Envelope>
  getReferralDrugPrices: (data: ReferralDrugPriceRequest) => Promise<ReferralDrugPriceResponse>
  getSubmissionCommunityTotals: (
    data: SubmissionCommunityTotalsRequest,
  ) => Promise<SubmissionCommunityTotalsResponse>
  getFacilitiesByPatientId: (patientId: number) => Promise<Envelope>
}

export const useReferralsService = (): Readonly<ReferralsServiceOperators> => {
  const dispatch = useAppDispatch()
  return {
    importReferralFile: useCallback((data: FormData) => importReferral(data), []),

    getReferralList: useCallback(
      (data: TableGenericRequest, endPoint: string) => TableDataCall(data, endPoint),
      [],
    ),

    getActivityLogList: useCallback((data: ActivityLogsRequest) => getActivityLogs(data), []),

    addNewParentOrChildReferral: useCallback(
      (data: Referral) => saveNewParentOrChildReferral(data),
      [],
    ),
    updateChildReferral: useCallback((data: Referral) => updateChildReferral(data), []),
    updateParentReferral: useCallback((data: Referral) => updateParentReferral(data), []),

    getChildReferralDetail: useCallback((id: number) => getChildReferralDetail(id), []),
    getParentReferralDetail: useCallback(
      (data: ParentReferralDetailRequest) => getParentReferralDetail(data),
      [],
    ),
    putReferralList: useCallback(
      data => {
        dispatch(referralActions.setReferralList(data))
      },
      [dispatch],
    ),
    referralList: useAppSelector(selectReferralList),
    putReferralDetail: useCallback(
      data => {
        dispatch(referralActions.setReferralDetail(data))
      },
      [dispatch],
    ),
    putReferralMcmStatus: useCallback(
      (data: AdmissionStats) => {
        dispatch(referralActions.setReferralMcmStatus(data))
      },
      [dispatch],
    ),
    referralDetail: useAppSelector(selectReferralDetail),
    addNewAttachment: useCallback((data: FormData) => saveNewAttachments(data), []),
    referralManualUpload: useCallback((data: FormData) => importReferralFile(data), []),

    setSelectedKeyword: useCallback(keywords => {
      dispatch(referralActions.setSelectedKeyword(keywords))
    }, []),
    getSelectedKeyword: useAppSelector(getSelectedKeyword),
    setAllKeyword: useCallback(keywords => {
      dispatch(referralActions.setAllKeyword(keywords))
    }, []),
    getAllKeyword: useAppSelector(getAllKeyword),
    setParentFilterItems: useCallback(filters => {
      dispatch(referralActions.setParentFilterItems(filters))
    }, []),
    getParentFilterItems: useAppSelector(getParentFilterItems),
    setChildFilterItems: useCallback(filters => {
      dispatch(referralActions.setChildFilterItems(filters))
    }, []),
    setGridStatusFilterItems: useCallback(filters => {
      dispatch(referralActions.setGridStatusFilterItems(filters))
    }, []),
    getChildFilterItems: useAppSelector(getChildFilterItems),
    getDefaultViewApplied: useAppSelector(getDefaultViewApplied),
    setDefaultViewApplied: useCallback(applied => {
      dispatch(referralActions.setDefaultViewApplied(applied))
    }, []),

    setIsQuestionAnswersLoaded: useCallback(isloaded => {
      dispatch(referralActions.setIsQuestionAnswersLoaded(isloaded))
    }, []),
    getIsQuestionAnswersLoaded: useAppSelector(getIsQuestionAnswersLoaded),

    getReferralSourcePdf: useCallback(
      (patientId: number, isHighlightedPdf: boolean) =>
        getReferralSourcePdf(patientId, isHighlightedPdf),
      [],
    ),
    getAttachmentDoc: useCallback((id: number) => getAttachmentDoc(id), []),

    getQuestionView: useCallback((data: QuestionRequest) => getQuestionView(data), []),
    saveSubmitQuestion: useCallback((data: AnswerList) => submitQuestion(data), []),
    getQuestionAnswers: useCallback(data => getQuestionAnswers(data), []),

    holdReferral: useCallback((data: HoldReferral) => setHoldReferral(data), []),
    lostReferral: useCallback((data: LostReferral) => setLostReferral(data), []),
    bulkHoldReferral: useCallback((data: BulkHoldRequest) => setBulkHoldReferral(data), []),
    bulkLostReferral: useCallback((data: BulkLostRequest) => setBulkLostReferral(data), []),
    bulkCommunityReview: useCallback(
      (data: BulkCommunityReviewRequest) => setBulkCommunityReview(data),
      [],
    ),

    getReferralGridview: useCallback(
      (permission: number[]) => getReferralForGridview(permission),
      [],
    ),
    getRefList: useCallback((data: CardReferral) => getRefLists(data), []),

    getPatientList: useCallback((id: number) => getPatientMatch(id), []),

    savePendingRequest: useCallback((data: PendingPatient) => savePendingPatient(data), []),
    submitToHchb: useCallback((data: HchbSubmitRequest) => submitReferralToHchb(data), []),
    markInsuranceValidation: useCallback(
      (data: MarkInsuranceValidationRequest) => markInsuranceValidation(data),
      [],
    ),
    updateChildReferralStatus: useCallback(
      (patientId: number, statusId: number, userId?: string, roleId?: string) =>
        childReferralStatusUpdate(patientId, statusId, userId, roleId),
      [],
    ),
    updateChildReferralApproveReject: useCallback(
      (data: ReferralApproveRejectRequest) => childReferralApproveReject(data),
      [],
    ),

    setReferralTriggering: useCallback(
      (data: { patientId: number }) => referralManualTriggering(data),
      [],
    ),

    getCommentLogList: useCallback((id: number) => getCommentLogs(id), []),

    getSexOffenderLists: useCallback(id => getSexOffenderList(id), []),
    applySexOffenderMatch: useCallback(body => sexOffenderMatch(body), []),

    getDenialReasons: useCallback((id: number) => getRefDenialReasons(id), []),
    setCategoryDetails: useCallback(categories => {
      dispatch(referralActions.setCategoryDetailList(categories))
    }, []),
    getCategoryDetails: useAppSelector(getCategoryDetailList),

    setWaystarMatch: useCallback(waystarMatch => {
      dispatch(referralActions.setWaystarMatch(waystarMatch))
    }, []),
    setPVerifyMatch: useCallback(pVerifyMatch => {
      dispatch(referralActions.setPVerifyMatch(pVerifyMatch))
    }, []),
    getPayerList: useCallback(() => getPayerLists(), []),
    waystarMatchRequest: useCallback(body => waystarMatchRequest(body), []),
    waystarPayerDelete: useCallback(body => waystarDelete(body), []),
    waystarSubmit: useCallback(patientId => wayStarSubmit(patientId), []),
    waystarValidate: useCallback(body => wayStarValidate(body), []),

    getSelectedReferral: useAppSelector(getSelectedReferral),
    setSelectedReferral: useCallback(id => {
      dispatch(referralActions.setSelectedReferral(id))
    }, []),

    selectedParentReferral: useAppSelector(selectedParentReferral),
    setSelectedParentReferral: useCallback(id => {
      dispatch(referralActions.setSelectedParentReferral(id))
    }, []),

    getSelectedListTab: useAppSelector(getSelectedListTab) ?? 1,
    setSelectedListTab: useCallback(tabId => {
      dispatch(referralActions.setSelectedListTab(tabId))
    }, []),
    getSelectedParentTab: useAppSelector(getSelectedParentTab) ?? 1,
    setSelectedParentTab: useCallback(tabId => {
      dispatch(referralActions.setSelectedParentTab(tabId))
    }, []),
    getCapabilityViewMode: useAppSelector(getCapabilityViewMode) ?? 1,
    setCapabilityViewMode: useCallback(mode => {
      dispatch(referralActions.setCapabilityViewMode(mode))
    }, []),
    getCapabilityExpandedAccordion:
      useAppSelector(getCapabilityExpandedAccordion) ?? 'capabilities',
    setCapabilityExpandedAccordion: useCallback(panel => {
      dispatch(referralActions.setCapabilityExpandedAccordion(panel))
    }, []),
    getClinicalReviewAccordionPreference: useAppSelector(getClinicalReviewAccordionPreference),
    setClinicalReviewAccordionPreference: useCallback(preference => {
      dispatch(referralActions.setClinicalReviewAccordionPreference(preference))
    }, []),
    deleteReferral: useCallback(data => deleteReferral(data), []),
    deleteParentReferral: useCallback(data => deleteParentReferral(data), []),

    updateParentReferralStatus: useCallback(
      (data: ParentCommunityListRequest) => parentReferralStatusUpdate(data),
      [],
    ),
    updateParentReferralApproveReject: useCallback(
      (data: ParentReferralApproveReject) => parentReferralApproveReject(data),
      [],
    ),
    updateParentReferralSkip: useCallback(
      (data: ParentReferralApproveReject) => parentReferralSkip(data),
      [],
    ),
    updateChildReferralSkip: useCallback(
      (data: ChildReferralSkipSubmitRequest) => childReferralSkip(data),
      [],
    ),
    getParentReferralFacilities: useCallback(
      (data: ParentCommunityListRequest) => parentReferralFacilities(data),
      [],
    ),
    getParentReferralFacilitiesForSkip: useCallback(
      (data: CommunityListForSkipRequest) => parentReferralFacilitiesForSkip(data),
      [],
    ),
    updateClinicalReviewStatus: useCallback(
      (data: SubmitClinicalReviewParentDTO) => updateClinicalReviewStatus(data),
      [],
    ),
    updateClinicalReviewStatusChild: useCallback(
      (data: SubmitClinicalReviewChildDTO) => updateClinicalReviewStatusChild(data),
      [],
    ),
    getFacilitiesForClinicalReview: useCallback(
      (data: ParentCommunityListRequest) => getFacilitiesForClinicalReview(data),
      [],
    ),
    getAllRoutes: useCallback(() => getRoutes(), []),
    getRoutesForRefSources: useCallback(() => getRoutesForReferralSource(), []),
    setRouteList: useCallback(list => {
      dispatch(referralActions.setRouteList(list))
    }, []),
    getRouteList: useAppSelector(getRouteList),

    setRefRouteList: useCallback(list => {
      dispatch(referralActions.setRefRouteList(list))
    }, []),
    getRefRouteList: useAppSelector(getRefRouteList),

    setSourceHospitalList: useCallback(list => {
      dispatch(referralActions.setSourceHospitalList(list))
    }, []),

    setGridViewAccordionDetails: useCallback(data => {
      dispatch(referralActions.setGridViewAccordionDetails(data))
    }, []),
    gridViewAccordionDetails: useAppSelector(getGridViewAccordionDetails),
    setGridViewZoomedListId: useCallback(data => {
      dispatch(referralActions.setGridViewZoomedListId(data))
    }, []),
    gridViewZoomedListId: useAppSelector(getGridViewZoomedListId),

    sourceHospitalList: useAppSelector(getSourceHospitalList),
    setOrganizationList: useCallback(list => {
      dispatch(referralActions.setOrganizationList(list))
    }, []),

    setMappedPverifyPayorsFullList: useCallback(list => {
      dispatch(referralActions.setMappedPverifyPayorsList(list))
    }, []),
    organizationList: useAppSelector(getOrganizationList),

    getAllReferralStatus: useCallback((permission: number[]) => getReferralStatus(permission), []),
    referralListRoot: useAppSelector(getReferralListRoot),
    setReferralListRoot: useCallback(type => {
      dispatch(referralActions.setReferralListRoot(type))
    }, []),
    getIntegrationFeatures: useCallback((id: number) => getIntegrationFeatures(id), []),
    sendOutBoundCommunication: useCallback(
      (data: OutboundMessageRequest) => sendOutBoundCommunication(data),
      [],
    ),
    getMessagesFromSource: useCallback(requestBody => getMessagesFromSource(requestBody), []),
    getRefreshForSourceMessageData: useAppSelector(getRefreshForSourceMessageData),
    setRefreshForSourceMessageData: useCallback(data => {
      dispatch(referralActions.setRefreshForSourceMessageData(data))
    }, []),
    getRefreshForRefList: useAppSelector(getRefreshForRefList),
    setRefreshForRefList: useCallback(() => {
      dispatch(referralActions.setRefreshRefList())
    }, []),
    reviseChildReferralStatus: useCallback(
      (patientId: number, statusId: number) => childReferralStatusRevise(patientId, statusId),
      [],
    ),
    reviseToClinicalReview: useCallback(
      (patientId: number, statusId: number, note: string) =>
        callReviseToClinicalReview(patientId, statusId, note),
      [],
    ),
    getSourceMessageTabToSet: useAppSelector(getSourceMessageTabToSet),
    setSourceMessageTabToSet: useCallback(tabVal => {
      dispatch(referralActions.setSourceMessageTabToSet(tabVal))
    }, []),

    getTodoList: useCallback(data => getTodoList(data), []),
    updateTodoItem: useCallback(data => updateTaskListStatus(data), []),
    getReferralListInputs: useAppSelector(getReferralListInputs),
    setReferralListInputs: useCallback((type, data) => {
      dispatch(referralActions.setReferralListInputs({ type, data }))
    }, []),
    getPccPatientDetails: useCallback(
      (orgUuid: string, patientId: number) => getPccPatientDetails(orgUuid, patientId),
      [],
    ),

    getRecentDenialReason: useCallback(data => getMostRecentDenialReason(data), []),
    getIsTaskListPending: useAppSelector(getIsTaskListPending),
    setIsTaskListPending: useCallback(data => {
      dispatch(referralActions.setIsTaskListPending(data))
    }, []),
    getIntegrationSourceStatus: useCallback((id: number) => getIntegrationSourceStatus(id), []),
    getInsuranceDetailsByPatientId: useCallback(
      (data: InsuranceDetailReq) => getInsuranceDetailsByPatientId(data),
      [],
    ),
    setWaystarValidationChanged: useCallback(() => {
      dispatch(referralActions.setWaystarValidationChanged())
    }, []),
    setPVerifyValidationChanged: useCallback(() => {
      dispatch(referralActions.setPVerifyValidationChanged())
    }, []),
    waystarValidationChanged: useAppSelector(waystarValidationChanged),
    pVerifyValidationChanged: useAppSelector(pVerifyValidationChanged),

    getHoldReasons: useCallback(() => callHoldReasons(), []),
    getHoldReasonsByOrg: useCallback(
      (body: HoldRationaleByOrgReq) => callHoldReasonsByOrg(body),
      [],
    ),
    setHoldReasons: useCallback(list => {
      dispatch(referralActions.setHoldReasons(list))
    }, []),
    holdReasons: useAppSelector(getHoldReasons),

    getLostReasons: useCallback(() => callLostReasons(), []),
    getLostReasonsByOrg: useCallback(
      (body: HoldRationaleByOrgReq) => callLostReasonsByOrg(body),
      [],
    ),
    setLostReasons: useCallback(list => {
      dispatch(referralActions.setLostReasons(list))
    }, []),
    lostReasons: useAppSelector(getLostReasons),
    unlockReferral: useCallback((data: UnLockReferralData) => unLockReferral(data), []),
    unmappedCommunitiesList: useCallback((data: string) => getUnmappedCommunities(data), []),
    mappedCommunitiesList: useCallback(
      (data: MappedCommunitiesRequest) => getMappedCommunities(data),
      [],
    ),
    getCommunitiesForUnmatched: useCallback(
      (data: CommunitiesForUnmatchedRequest) => getCommunitiesForUnmatched(data),
      [],
    ),
    addMappedCommunity: useCallback(
      (data: AddMappedCommunityRequest) => addMappedCommunity(data),
      [],
    ),
    updateMappedCommunity: useCallback(
      (data: AddMappedCommunityRequest) => updateMappedCommunity(data),
      [],
    ),
    regeneratePDF: useCallback((data: { patientId: number }) => referralRegeneratePDF(data), []),
    setDenialReasonList: useCallback(list => {
      dispatch(referralActions.setDenialReasonList(list))
    }, []),
    denialReasonList: useAppSelector(getDenialReasonList),
    setReferralGridViewList: useCallback(list => {
      dispatch(referralActions.setReferralGridViewList(list))
    }, []),
    referralGridViewList: useAppSelector(getReferralGridViewList),

    setFacilityListForParentFilter: useCallback(list => {
      dispatch(referralActions.setFacilityListForParentFilter(list))
    }, []),
    facilityListForParentFilter: useAppSelector(getFacilityListForParentFilter),
    setFacilityListForChildFilter: useCallback(list => {
      dispatch(referralActions.setFacilityListForChildFilter(list))
    }, []),
    facilityListForChildFilter: useAppSelector(getFacilityListForChildFilter),
    mappedPverifyPayorsFullList: useAppSelector(getMappedPverifyPayorsFullList),

    insuranceProvider: useAppSelector(getInsuranceProvider),
    setInsuranceProvider: useCallback((type: number) => {
      dispatch(referralActions.setInsuranceProvider(type))
    }, []),
    pVerifyLinks: useAppSelector(getPVerifyLinks),
    setPVerifyLinks: useCallback((data: PVerifyLinks) => {
      dispatch(referralActions.setPVerifyLinks(data))
    }, []),
    getPVerifyPayerList: useCallback(() => getPverifyPayerLists(), []),
    pVerifyMatchRequest: useCallback(body => pVerifyMatchRequest(body), []),
    pVerifySubmit: useCallback((data: PVerifySubmitObject) => pVerifySubmit(data), []),
    pVerifyValidate: useCallback(body => pVerifyValidate(body), []),
    savePayerNote: useCallback((body: SavePayerNoteRequest) => savePayerNote(body), []),
    deletePayerNote: useCallback((id: number) => deletePayerNote(id), []),
    reorderInsurance: useCallback((body: ReorderInsuranceRequest) => reorderInsurance(body), []),
    pVerifyPayerDelete: useCallback(body => pVerifyDeletePayer(body), []),
    getAssignUsersList: useCallback((data: AssignLeads) => fetchAssignUsersList(data), []),
    fetchAssignedUsersList: useCallback((data: AssignedUsersReq) => assignedUsersList(data), []),
    deleteAssignedRefUser: useCallback((data: DeleteAssignedUserReq) => deleteLeadAgent(data), []),
    addReferralUsers: useCallback((data: AddUsersReq) => addReferralUsers(data), []),
    getAssignedUsersCount: useCallback((data: number) => assignedUsersCount(data), []),
    confirmReadAlert: useCallback((data: ConfirmReadAlertRequest) => confirmReadAlert(data), []),
    getReferralUpdates: useCallback((data: number) => fetchReferralUpdates(data), []),
    setReferralComparisonId: useCallback(data => {
      dispatch(referralActions.setReferralComparisonId(data))
    }, []),
    getSourceHospitalList: useCallback(() => getAllSourceHospitals(), []),
    getCommunityFaxStatus: useCallback((data: CommunityFaxReq) => getCommunityFaxStatus(data), []),
    getParentFaxStatus: useCallback((data: CommunityFaxReq) => getParentFaxStatus(data), []),
    faxStatusRefresh: useAppSelector(getFaxStatusRefresh),
    setFaxStatusRefresh: useCallback(() => {
      dispatch(referralActions.setFaxStatusRefresh())
    }, []),
    setOcrCompletionStatus: useCallback(data => {
      dispatch(referralActions.setOcrCompletionStatus(data))
    }, []),
    setAIProcessingStatus: useCallback(data => {
      dispatch(referralActions.setAIProcessingStatus(data))
    }, []),
    getQueuedChildReferralDetail: useCallback(
      (id: number) => fetchQueuedChildReferralDetail(id),
      [],
    ),
    getQueuedParentReferralDetail: useCallback(
      (id: number) => fetchQueuedParentReferralDetail(id),
      [],
    ),
    getAIGenerationStatusForQA: useCallback((id: number) => getAIGenerationStatusForQA(id), []),
    getAIGenerationStatusForParentQA: useCallback(
      (id: number) => getAIGenerationStatusForParentQA(id),
      [],
    ),
    getAIGenerationStatusForCommunityQA: useCallback(
      (id: number) => getAIGenerationStatusForCommunityQA(id),
      [],
    ),
    clearIndividualParentFilter: useCallback(data => {
      dispatch(referralActions.clearIndividualParentFilter(data))
    }, []),
    clearIndividualChildFilter: useCallback(data => {
      dispatch(referralActions.clearIndividualChildFilter(data))
    }, []),
    resetChildFilterItems: useCallback(() => {
      dispatch(referralActions.setChildFilterItems(undefined))
    }, []),
    resetParentFilterItems: useCallback(() => {
      dispatch(referralActions.setParentFilterItems(undefined))
    }, []),
    showDocument: useAppSelector(getShowDocumentBool),
    setShowDocument: useCallback(() => {
      dispatch(referralActions.setShowDocument())
    }, []),
    updateInsurance: useCallback((data: InsuranceInfo) => updateInsurance(data), []),
    manuallyAdmitRef: useCallback((data: RefManualAdmitReq) => manuallyAdmitRef(data), []),
    addNotes: useCallback((data: CreateNotes) => addNotes(data), []),
    editNotes: useCallback((data: EditNotes) => editNotes(data), []),
    deleteNotes: useCallback((id: number) => deleteNotes(id), []),
    getNotesById: useCallback((id: number) => getNoteById(id), []),
    createCustomFilter: useCallback((data: CreateCustomFilter) => createCustomFilter(data), []),
    editCustomFilter: useCallback((data: EditCustomFilter) => editCustomFilter(data), []),
    deleteCustomFilter: useCallback((id: string) => deleteCustomFilter(id), []),
    getAllCustomFilter: useCallback(
      (id: string, filterModule: number, isParentList: boolean) =>
        getAllCustomFilter(id, filterModule, isParentList),
      [],
    ),
    setDefaultCustomFilter: useCallback(
      (data: SetDefaultCustomFilter) => setDefaultCustomFilter(data),
      [],
    ),
    getAllNotes: useCallback((data: AllNotesList) => getAllNotes(data), []),
    getEngagementTypesForNotes: useCallback(() => getEngagementTypesForNotes(), []),
    sendBroadcastOutBoundCommunication: useCallback(
      (data: BroadcastOutboundMessageRequest) => createBroadcastOutBoundCommunication(data),
      [],
    ),
    getSelectedPatientFacilityId: useAppSelector(getSelectedPatientFacilityId) ?? 1,
    setSelectedPatientFacilityId: useCallback(id => {
      dispatch(referralActions.setSelectedPatientFacilityId(id))
    }, []),
    reloadPatientRefdata: useAppSelector(getReloadPatientRefdata),
    setReloadPatientRefdata: useCallback(() => {
      dispatch(referralActions.setReloadPatientRefdata())
    }, []),
    getChildRefdataForNav: useAppSelector(getChildRefdataForNav),
    setChildRefdataForNav: useCallback(data => {
      dispatch(referralActions.setChildRefdataForNav(data))
    }, []),
    unlockQueuedReferral: useCallback((data: UnLockReferralData) => unLockQueuedReferral(data), []),
    showLock: useAppSelector(getShowLock),
    assignedUsers: useAppSelector(getSelectedAssignedUsers),
    setShowLock: useCallback(data => {
      dispatch(referralActions.setShowLock(data))
    }, []),
    setAssignedUsers: useCallback(data => {
      dispatch(referralActions.setSelectedAssignedUsers(data))
    }, []),
    setNoteTypeFullList: useCallback(data => {
      dispatch(referralActions.setNoteTypeFullList(data))
    }, []),
    getNoteTypeFullList: useAppSelector(getNoteTypeFullList),
    lockQueuedReferral: useCallback((data: number) => lockQueuedReferral(data), []),
    getMatchedPayerList: useCallback(() => getMatchedPayerList(), []),
    getAssignedUserList: useCallback((data: AssignedUsers) => getAssignedUserList(data), []),
    setSourcehospListForParentFilter: useCallback(list => {
      dispatch(referralActions.setSourcehospListForParentFilter(list))
    }, []),
    setSourcehospListForChildFilter: useCallback(list => {
      dispatch(referralActions.setSourcehospListForChildFilter(list))
    }, []),
    sourcehospListForChildFilter: useAppSelector(getSourcehospListForChildFilter),
    sourcehospListForParentFilter: useAppSelector(getSourcehospListForParentFilter),
    customColumnFilters: useAppSelector(getCustomColumn),
    setCustomColumnFilter: useCallback((data: CustomColumnReq) => {
      dispatch(referralActions.setCustomColumns(data))
    }, []),

    createPrimaryRationale: useCallback(
      (data: AddPrimaryRationaleReq) => addPrimaryRationale(data),
      [],
    ),
    updatePrimaryRationale: useCallback(
      (data: UpdatePrimaryRationaleReq) => updatePrimaryRationale(data),
      [],
    ),
    deletePrimaryRationale: useCallback((id: string) => deletePrimaryRationale(id), []),
    createSecondaryRationale: useCallback(
      (data: DenialReasonReq) => addSecondaryRationale(data),
      [],
    ),
    updateSecondaryRationale: useCallback(
      (data: UpdateDenialReasonReq) => updateSecondaryRationale(data),
      [],
    ),
    deleteSecondaryRationale: useCallback((id: string) => deleteSecondaryRationale(id), []),
    getSecondaryRationaleByOrg: useCallback(
      (data: RationaleList) => getSecRationaleByOrg(data),
      [],
    ),
    getSecondaryRationaleDetails: useCallback((id: number) => getSecRationaleDetails(id), []),
    getPrimaryRationale: useCallback((id: number) => getPrimaryRationalesByOrg(id), []),
    getReferralSourceRoute: useCallback(() => getRationalesRoutes(), []),
    getReferralSourceRationalesByRoute: useCallback(
      (id: number | null) => getReferralSourceRationaleByRoute(id ?? null),
      [],
    ),
    setLostRationaleListForParentFilter: useCallback(list => {
      dispatch(referralActions.setLostRationaleListForParentFilter(list))
    }, []),
    setLostRationaleListForChildFilter: useCallback(list => {
      dispatch(referralActions.setLostRationaleListForChildFilter(list))
    }, []),
    lostRationaleListForChildFilter: useAppSelector(getLostRationaleListForChildFilter),
    lostRationaleListForParentFilter: useAppSelector(getLostRationaleListForParentFilter),
    setHoldRationaleListForParentFilter: useCallback(list => {
      dispatch(referralActions.setHoldRationaleListForParentFilter(list))
    }, []),
    setHoldRationaleListForChildFilter: useCallback(list => {
      dispatch(referralActions.setHoldRationaleListForChildFilter(list))
    }, []),
    holdRationaleListForChildFilter: useAppSelector(getHoldRationaleListForChildFilter),
    holdRationaleListForParentFilter: useAppSelector(getHoldRationaleListForParentFilter),
    getRefScreenPanels: useCallback((id: number) => getReferralScreenPanels(id), []),
    saveRefScreenPanels: useCallback((data: RefPanelObject) => saveReferralScreenPanels(data), []),
    deleteRefScreenPanels: useCallback(
      (screenKey: number, panelKey: number) => deleteReferralScreenPanels(screenKey, panelKey),
      [],
    ),
    getParentRefOfDuplicateRefs: useAppSelector(getParentRefOfDuplicateRefs),
    setParentRefOfDuplicateRefs: useCallback(id => {
      dispatch(referralActions.setParentRefOfDuplicateRefs(id))
    }, []),
    getDuplicateReferralList: useCallback((data: DuplicaterefReq) => getDuplicateRefList(data), []),
    isParentPathOrigin: useAppSelector(isParentPathOrigin),

    setIsParentPathOrigin: useCallback(val => {
      dispatch(referralActions.setIsParentPathOrigin(val))
    }, []),
    isQueuedPathOrigin: useAppSelector(isQueuedPathOrigin),

    setIsQueuedPathOrigin: useCallback(val => {
      dispatch(referralActions.setIsQueuedPathOrigin(val))
    }, []),
    getQueuedchildRefId: useAppSelector(getQueuedchildRefId),
    setQueuedchildRefId: useCallback(id => {
      dispatch(referralActions.setQueuedchildRefId(id))
    }, []),
    getQueuedFileId: useAppSelector(getQueuedFileId),
    setQueuedFileId: useCallback(id => {
      dispatch(referralActions.setQueuedFileId(id))
    }, []),
    isDialogOpen: useAppSelector(isDialogOpen),

    setIsDialogOpen: useCallback(val => {
      dispatch(referralActions.setIsDialogOpen(val))
    }, []),
    isNotesDrawerOpen: useAppSelector(isNotesDrawerOpen),
    setIsNotesDrawerOpen: useCallback(val => {
      dispatch(referralActions.setIsNotesDrawerOpen(val))
    }, []),
    noteIdToEdit: useAppSelector(getNoteIdToEdit),
    setNoteIdToEdit: useCallback(id => {
      dispatch(referralActions.setNoteIdToEdit(id))
    }, []),
    isSideDrawerOpen: useAppSelector(isSideDrawerOpen),
    setIsSideDrawerOpen: useCallback(val => {
      dispatch(referralActions.setIsSideDrawerOpen(val))
    }, []),
    deleteRule: useCallback((id: number) => deleteRule(id), []),
    pauseRule: useCallback((id: number, pauseState: boolean) => pauseRule(id, pauseState), []),
    getAllCategoryDomo: useCallback(() => getAllCategoryDomo(), []),
    getAllOrganizationDomo: useCallback(() => getAllOrganizationDomo(), []),
    getSexOffenderCheckRslt: useCallback((id: number) => getSexOffenderCheckRslt(id), []),
    getInsuranceCheckRslt: useCallback((id: number) => getInsuranceCheckRslt(id), []),
    getReferralCommunityCapability: useCallback(
      (data: ReferralCapabilityRequestPayload) => getReferralCommunityCapability(data),
      [],
    ),
    getCommunityCapabilities: useCallback(
      (data: CommunityCapabilitiesReqBody) => getCommunityCapabilities(data),
      [],
    ),
    addCapabilitiesReferral: useCallback(
      (data: AddCapabilityReferralReqBody) => addCapabilitiesReferral(data),
      [],
    ),
    saveReferralCapabilities: useCallback(
      (data: ReferralCapabilitiesData) => saveReferralCapabilities(data),
      [],
    ),
    getFacilitiesByPatientId: useCallback(
      (patientId: number) => getFacilitiesByPatientId(patientId),
      [],
    ),
    putReferralAttachmentDetail: useCallback(
      data => {
        dispatch(referralActions.setReferralAttachment(data))
      },
      [dispatch],
    ),
    getManagedCareMasterAdmissionStatus: useCallback(
      (patientFacilityId: number) => fetchManagedCareMasterAdmissionStatus(patientFacilityId),
      [],
    ),
    triggerManagedCareMasterAdmission: useCallback(
      (data: MCMTriggerStatus) => triggerManagedCareMaster(data),
      [],
    ),
    updateMcmRequiredFields: useCallback(
      (data: MCMFieldsUpdateRequest) => updateReferralMcmFields(data),
      [],
    ),
    getReferralDrugPrices: useCallback(
      (data: ReferralDrugPriceRequest) => getReferralDrugPrices(data),
      [],
    ),
    getSubmissionCommunityTotals: useCallback(
      (data: SubmissionCommunityTotalsRequest) => getSubmissionCommunityTotals(data),
      [],
    ),
  }
}

export default useReferralsService
